/**
 * Ryan O'Dowd
 * 2024-09-22
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      borderRadius: 6 * globalScale,
      backgroundColor: `${colors.primaryDark}aa`,
      padding: 4,
    },
    touchable: {
      flexGrow: 1,
      flexShrink: 1,
    },
    brickTitle: {
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 14,
      color: colors.brickTitle,
    },
    actionIcon: { // @TODO: would like to reuse this (in MainDashboard/styles.native.js)
      fontSize: globalScale * 16,
    },
  };
};

export default getStyles;
